module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/terms/terms-grid/terms-grid.component.css
// module id = ./src/app/components/terms/terms-grid/terms-grid.component.css
// module chunks = main